export default class Key {
  constructor(API) {
    this.api = API;
  }
  async getAvailableKeys(externalID, licensesCount, productID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/keys/' + externalID;
    req.appendQueryParam('numberOfLicenses', licensesCount);
    if (productID) req.appendQueryParam('productID', productID);
    return await req.exec();
  }
  async getKey(activationKey, expanded = false) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/activationKey/' + activationKey + (expanded ? '?expanded=true' : '');
    return await req.exec();
  }
  async getKeyAssignments(activationKey) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/activationKey/' + activationKey + '/assignments';
    return await req.exec();
  }
  async getKeyConsumption(activationKey) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/activationKey/' + activationKey + '/consumption';
    return await req.exec();
  }
  async getKeyReservations(activationKey) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/activationKey/${activationKey}/reservations`;
    return await req.exec();
  }
  async getAssignedKeys(externalID, assignedTo, productID, showConsumed) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/keys/' + externalID + '/assigned';
    if (assignedTo) req.appendQueryParam('assignedTo', assignedTo);
    if (productID) req.appendQueryParam('productID', productID);
    req.appendQueryParam('showConsumed', showConsumed);
    return await req.exec();
  }

  async getAvailableActivationKeys(externalID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/activationKeys/' + externalID + '/available';
    return await req.exec();
  }
}
